<template>
  <div class="container-fluid">
    <div class="container p-0 card_background_effect">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-md-0">
          <div class="login-form d-flex">
            <form class="sign-in-sign-up-form w-100"
                  ref="form"
                  :data-url="addUrl"
                  method="post"
                  :class="{ 'loading-opacity': preloader }">
              <div class="text-center mb-4">
                <img :src="companyInfo.logo
                  ? companyInfo.logo
                  :  `<h6>
                  {{companyInfo.company_name}}
                </h6>`
                  "
                     alt=""
                     class="img-fluid logo"/>

              </div>
              <div class="row" v-if="!showCompletedStatus">
                <div class="col-sm-1 col-md-2"
                     v-if="isMobile === 'vertical'">
                  <div style="height: auto">
                    <el-steps direction="vertical"
                              :active="active">
                      <el-step title="Basic Information"
                               @click.native="e => stepClick(e, 0)"/>
                      <el-step title="Bank A/c Details"
                               @click.native="e => stepClick(e, 1)"/>
                      <el-step title="Addresses"
                               @click.native="e => stepClick(e, 2)"/>
                      <el-step title="Trainings"
                               @click.native="e => stepClick(e, 3)"/>
                      <el-step title="Previous History"
                               @click.native="e => stepClick(e, 4)"/>
                      <el-step title="SIA Questionnaire"
                               @click.native="e => stepClick(e, 5)"/>
                      <el-step title="Upload Documents"
                               @click.native="e => stepClick(e, 6)"/>
                      <el-step title="GDPR Notice"
                               @click.native="e => stepClick(e, 7)"/>
                    </el-steps>
                  </div>
                </div>
                <div class="col-md-12 scroll-container"
                     v-if="isMobile === 'horizontal'">
                  <div class="scroll-content">
                    <div style="height: auto">
                      <el-steps direction="horizontal"
                                :active="active">
                        <el-step title="Basic Information"
                                 @click.native="e => stepClick(e, 0)"/>
                        <el-step title="Bank A/c Details"
                                 @click.native="e => stepClick(e, 1)"/>
                        <el-step title="Addresses"
                                 @click.native="e => stepClick(e, 2)"/>
                        <el-step title="Trainings"
                                 @click.native="e => stepClick(e, 3)"/>
                        <el-step title="Employment History"
                                 @click.native="e => stepClick(e, 4)"/>
                        <el-step title="SIA Questionnaire"
                                 @click.native="e => stepClick(e, 5)"/>
                        <el-step title="Upload Documents"
                                 @click.native="e => stepClick(e, 6)"/>
                        <el-step title="GDPR Notice"
                                 @click.native="e => stepClick(e, 7)"/>
                      </el-steps>
                    </div>
                  </div>
                </div>
                <div :class=" isMobile == 'vertical' ? 'col-sm-11 col-md-10' : 'col-md-12'">
                  <el-form v-if="active === 0">
                    <basic-info :basic_info="basicInfo"
                                :yesOrNoList="yesOrNoList"
                                :isAdmin="false"
                    />
                  </el-form>
                  <el-form v-if="active === 1">
                    <payroll-info :payroll_info="payrollInfo" :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === 2">
                    <address-info :address_Info="addressInfo" :dateFormatter="dateFormatter"
                                  :isAdmin="false"
                                  :onSaveBtn="saveBtnHandler"
                    />
                  </el-form>
                  <el-form v-if="active === 3">
                    <training-info :yesOrNoList="yesOrNoList"
                                   :training_info="trainingInfo"
                                   :dateFormatter="dateFormatter"
                                   :onSaveBtn="saveBtnHandler"
                                   :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === 4">
                    <candidate-history :candidate_history_info="candidateHistoryInfo"
                                       :emailAddress="basicInfo.email"
                                       :dateFormatter="dateFormatter"
                                       :onSaveBtn="saveBtnHandler"
                                       :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === 5">
                    <sia-info :sia_Info="siaInfo" :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === 6">
                    <uploaded-documents-info :emailAddress="basicInfo.email" :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === maxStep">
                    <gdpr-notice-info :gdpr_info="gdprInfo" :isAdmin="false"/>
                  </el-form>
<!--                  <el-form >-->
<!--                    <policy-declaration-info :policy_declaration="policyDeclarationInfo"-->
<!--                                             :yesOrNoList="yesOrNoList"-->
<!--                                             :isAdmin="false"/>-->
<!--                  </el-form>-->
                </div>
              </div>
              <div class="text-center h-100" v-if="showCompletedStatus">
                <h4>Thank you for your interest, We will be in touch soon.</h4>
              </div>
              <div class="form-row mt-5 d-flex align-items-center position-sticky" v-if="!showCompletedStatus">
                <div class="p-2">
                  <el-button class="btn btn-primary el-button--default"
                             @click="previous"

                             v-if="this.active > 0">
                    Previous
                  </el-button>
                </div>
                <div class="p-2">
                  <el-button class="btn btn-primary el-button--default"
                             @click="next"
                             
                             v-if="this.active < maxStep">
                    Next
                  </el-button>
                </div>
                <div class="p-2" v-if="this.active >= 7">
                  <el-button class="btn btn-primary el-button--default"
                             @click="saveBtnHandler(false)">
                    {{ this.active < maxStep ? 'Save' : 'Submit' }}
                  </el-button>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <p class="text-center">
                    {{ $t("copyright_text") + configData.company_name }}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="row">
        <app-modal v-if="is_consent_modal"
                   modal-id="consent-modal"
                   modal-alignment="top"
                   modal-size="medium"
                   @close-modal="closeModal"
        >
          <template slot="header">
            <h5 class="modal-title">Policy and Declaration</h5>
          </template>
          <template slot="body">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <policy-declaration-info :policy_declaration="policyDeclarationInfo" :companyInfo="companyInfo"
                                         :yesOrNoList="yesOrNoList"
                                         :isAdmin="false"/>
              </div>
            </div>
          </template>
          <template slot="footer">
            <button
                type="button"
                class="btn btn-secondary mr-2"
                data-dismiss="modal"
                @click="closeModal">
              {{ $t("close") }}
            </button>
            <button
                type="button"
                class="btn btn-secondary mr-2"
                @click.prevent="acceptAll">
              {{ $t("Accept & Continue") }}
            </button>
          </template>
        </app-modal>

      </div>
    </div>
  </div>
</template>
<script>

import {SCREENING_USER_REGISTRATION} from '../../../../../../js/app/Config/ScreeningAppUrl';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
import {AuthMixin} from "../../Auth/Mixins/AuthMixin";
import moment from "moment";
import {_yesOrNoList} from '@Views/Screening/utility/constant';
import {dateFormatter, checkPolicyDeclaration} from '@Views/Screening/utility/common';
import {Candidate} from "@Views/Screening/utility/apiAgent";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import * as actions from "@/app/Config/ApiUrl";

export default {
  name: "CandidateRegistration",
  mixins: [FormMixin, AuthMixin],
  props: {
    companyInfo: Object,
    applicant: Object
  },
  mounted() {
    $("._remove_class").removeClass("el-button");
    this.getApplicantDetails();
    $("body").click(function () {
    });
  },
  created() {
    this.setPolicyDeclarationFields();
    this.is_consent_modal = true;

  },
  data() {
    return {
      showCompletedStatus: false,
      is_consent_modal: false,
      basicInfo: {},
      payrollInfo: {},
      addressInfo: [],
      trainingInfo: [],
      candidateHistoryInfo: [],
      siaInfo: [],
      policyDeclarationInfo: {},
      gdprInfo: {},
      nextButton: false,
      active: 0,
      preloader: false,
      registrationForm: {},
      activeIdCollection: [],
      yesOrNoList: _yesOrNoList,
      emailAddress: '',
      maxStep: 7,

    };
  },
  methods: {
    dateFormatter,
    checkPolicyDeclaration,
    next() {
      const isValidated = this.validator();
      if (isValidated == false) {
        return;
      }
      if (this.active === this.maxStep) {

        return;
      }
      let nextStep = this.active++;
      if (nextStep > this.maxStep) {
        this.active = 1;
      }
      this.activeIdCollection.push(this.active);
      $("#_remove_class_").removeClass("el-button");
      this.saveBtnHandler();
    },
    validator() {
      const lastIndex = (this.activeIdCollection.length - 1) === -1 ? 0 : (this.activeIdCollection.length - 1);
      if (this.activeIdCollection[lastIndex] === 2) {
        const isValid = this.addressHistoryValidation();
        return isValid;
      }
      if (this.activeIdCollection[lastIndex] === 4) {
        const isValid = this.candidateHistoryValidation();
        return isValid;
      }
      return true;
    },
    addressHistoryValidation() {
      if (this.addressInfo.length > 0) {
        const firstIterationToDate = this.addressInfo[0].to_date;
        const addressLastIndex = (this.addressInfo.length - 1) === -1 ? 0 : (this.addressInfo.length - 1);
        const lastIterationFromDate = this.addressInfo[addressLastIndex].from_date;
        const startDate = moment(lastIterationFromDate);
        const endDate = moment(firstIterationToDate);
        const yearsDiff = endDate.diff(startDate, 'years');
        if (yearsDiff < 3) {
          this.$toastr.i('You need to enter address history for last 3 years.');
          //return false;
        }
        return true;
      }
      // return false;
    },
    candidateHistoryValidation() {
      if (this.candidateHistoryInfo.length > 0) {
        const firstIterationToDate = this.candidateHistoryInfo[0].to_date;
        const candidateHistoryLastIndex = (this.candidateHistoryInfo.length - 1) === -1 ? 0 : (this.candidateHistoryInfo.length - 1);
        const lastIterationFromDate = this.candidateHistoryInfo[candidateHistoryLastIndex].from_date;
        const startDate = moment(lastIterationFromDate);
        const endDate = moment(firstIterationToDate);
        const yearsDiff = endDate.diff(startDate, 'years');
        if (yearsDiff < 5) {
          this.$toastr.i('You need to enter history for last 5 years.');
          //return false;
        }
        return true;
      }
      // return false;
    },
    previous() {
      if (this.active-- < this.maxStep) this.active = this.active--;
      if(this.active < 8){
        this.showCompletedStatus = false
      }
    },
    stepClick(_, id) {
      const isValidated = this.validator();
      if (isValidated == false) {
        return;
      }
      this.activeIdCollection.push(id);
      this.active = id;
    },
    beforeSubmit() {
      this.preloader = true;
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);

      this.$emit('afterSubmitDone');
    },
    afterFinalResponse() {
      this.preloader = false;
      this.registrationForm = {};
    },
    afterError() {
      this.preloader = false;
    },

    getEmailFromQueryString() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      return params.email ?? false;

    },
    getApplicantDetails() {
      let ifEmailInQueryString = this.getEmailFromQueryString();
      if(this.applicant){
        ifEmailInQueryString = this.applicant.email;
      }
      let _email = ifEmailInQueryString ?? localStorage.getItem('candidate-email');
      this.preloader = true;
      Candidate.getCandidateByEmail(_email)
          .then(({data}) => {
            if (data?.applicant && Object.values(data?.applicant).length > 0) {
              this.setApiResponseIntoBasicInfoProps(data.applicant);
              this.setApiResponseIntoPayrollProps(data.applicant?.applicant_payroll);
              this.setApiResponseIntoPolicyDeclrationProps(data.applicant?.applicant_policy_declaration);
              this.setApiResponseIntoGdprProps(data.applicant?.applicant_gdpr_detail);
              this.setApiResponseIntoTrainingProps(data.applicant?.applicant_training);
              this.setApiResponseIntoAddressProps(data.applicant?.applicant_address);
              this.setApiResponseIntoSIAProps(data.applicant?.applicant_sia_detail);
              this.setApiResponseIntoPreviousHistoryProps({
                employment: data.applicant?.applicant_employment,
                education: data.applicant?.applicant_education,
                selfEmployment: data.applicant?.applicant_self_employment,
                unEmployment: data.applicant?.applicant_unemployment,
                applicantEmail: data.applicant?.email,
              });
            } else if(_email) {
              this.$set(this.basicInfo, 'email', _email);
              // window.location.reload();
            }else{
              localStorage.removeItem('candidate-email');
            }
          })
          .finally(() => {
            this.preloader = false;
          });
    },
    setApiResponseIntoBasicInfoProps(applicant) {
      this.$set(this.basicInfo, 'full_name', applicant.full_name);
      this.$set(this.basicInfo, 'forename', applicant.forename);
      this.$set(this.basicInfo, 'middle_name', applicant.middle_name);
      this.$set(this.basicInfo, 'surname', applicant.surname);
      this.$set(this.basicInfo, 'n_i_number', applicant.n_i_number);
      this.$set(this.basicInfo, 'gender', applicant.gender);
      this.$set(this.basicInfo, 'date_of_birth', applicant.date_of_birth);
      this.$set(this.basicInfo, 'title', applicant.title);
      this.$set(this.basicInfo, 'country_of_birth', applicant.country_of_birth);
      this.$set(this.basicInfo, 'town_of_birth', applicant.town_of_birth);
      this.$set(this.basicInfo, 'photo_id_match', applicant.photo_id_match);
      this.$set(this.basicInfo, 'nationality', applicant.nationality);
      this.$set(this.basicInfo, 'edbs_number', applicant.edbs_number);
      this.$set(this.basicInfo, 'contact_number', applicant.contact_number ?? '');
      this.$set(this.basicInfo, 'alternative_contact_no', applicant.alternative_contact_no ?? '');
      this.$set(this.basicInfo, 'email', applicant.email);
      this.$set(this.basicInfo, 'relationship', applicant.relationship);
      this.$set(this.basicInfo, 'next_of_kin', applicant.next_of_kin);
      this.$set(this.basicInfo, 'next_of_kin_contact_no', applicant.next_of_kin_contact_no ?? '');
      this.$set(this.basicInfo, 'is_sia_required', applicant.is_sia_required === 1 ? true : false);
      this.$set(this.basicInfo, 'sia_license_number', applicant.sia_license_number);
      this.$set(this.basicInfo, 'sia_license_type', applicant.sia_license_type);
      this.$set(this.basicInfo, 'sia_license_expiry', applicant.sia_license_expiry);
      this.$set(this.basicInfo, 'is_additional_license', applicant.is_additional_license === 1 ? true : false);
      this.$set(this.basicInfo, 'additional_sia_license_number', applicant.additional_sia_license_number);
      this.$set(this.basicInfo, 'additional_sia_license_type', applicant.additional_sia_license_type);
      this.$set(this.basicInfo, 'additional_sia_license_expiry', applicant.additional_sia_license_expiry);
      this.$set(this.basicInfo, 'share_code', applicant.share_code);
      this.$set(this.basicInfo, 'share_code_start_date', applicant.share_code_start_date);
      this.$set(this.basicInfo, 'employee_picture', applicant.employee_picture);
      this.$set(this.basicInfo, 'is_visa_require_uk', applicant.is_visa_require_uk);
      this.$set(this.basicInfo, 'visa_type', applicant.visa_type);
      this.$set(this.basicInfo, 'biometric_residence_permit', applicant.biometric_residence_permit);
      this.$set(this.basicInfo, 'visa_expiry', applicant.visa_expiry);
      this.$set(this.basicInfo, 'date_of_entry_re_entry', applicant.date_of_entry_re_entry);
      this.$set(this.basicInfo, 'is_have_p45_or_p46', applicant.is_have_p45_or_p46);
      this.$set(this.basicInfo, 'copy_of_p45', applicant.copy_of_p45);
      this.$set(this.basicInfo, 'p46_detail', applicant.p46_detail);
      this.$set(this.basicInfo, 'is_other_employment', applicant.is_other_employment);
      this.$set(this.basicInfo, 'continue_other_employment', applicant.continue_other_employment);
      this.$set(this.basicInfo, 'is_leisure', applicant.is_leisure);
      this.$set(this.basicInfo, 'leisure_details', applicant.leisure_details);
      this.$set(this.basicInfo, 'is_criminal_record', applicant.is_criminal_record);
      this.$set(this.basicInfo, 'criminal_record_details', applicant.criminal_record_details);
      this.$set(this.basicInfo, 'is_bankruptcy', applicant.is_bankruptcy);
      this.$set(this.basicInfo, 'bankruptcy_details', applicant.bankruptcy_details);
      this.$set(this.basicInfo, 'is_days_shift_cant_work', applicant.is_days_shift_cant_work);
      this.$set(this.basicInfo, 'days_shift_cant_work_details', applicant.days_shift_cant_work_details);
      this.$set(this.basicInfo, 'is_holidays_commitment', applicant.is_holidays_commitment);
      this.$set(this.basicInfo, 'holidays_commitment_details', applicant.holidays_commitment_details);
      this.$set(this.basicInfo, 'is_own_vehicle', applicant.is_own_vehicle);
      this.$set(this.basicInfo, 'is_driving_license', applicant.is_driving_license);
      this.$set(this.basicInfo, 'driver_license_number', applicant.driver_license_number);
      this.$set(this.basicInfo, 'license_type', applicant.license_type);
      this.$set(this.basicInfo, 'license_issue_date', applicant.license_issue_date);
      this.$set(this.basicInfo, 'license_expiry_date', applicant.license_expiry_date);
      this.$set(this.basicInfo, 'licenses', applicant.licenses);
    },
    setApiResponseIntoPayrollProps(payroll) {
      if (payroll && Object.values(payroll).length > 0) {
        this.$set(this.payrollInfo, 'account_name', payroll.account_name);
        this.$set(this.payrollInfo, 'account_number', payroll.account_number);
        this.$set(this.payrollInfo, 'bank_name', payroll.bank_name);
        this.$set(this.payrollInfo, 'other_information', payroll.other_information);
        this.$set(this.payrollInfo, 'sort_code', payroll.sort_code);
      }
    },
    setApiResponseIntoAddressProps(address) {
      if (address && address.length > 0) {
        this.addressInfo = address;
      }
    },
    setApiResponseIntoTrainingProps(training) {
      if (training && training.length > 0) {
        this.trainingInfo = training;
      }
    },
    setApiResponseIntoPreviousHistoryProps(previousHistory) {
      if (previousHistory.employment && previousHistory.employment.length > 0) {
        for (const employment of previousHistory.employment) {
          this.candidateHistoryInfo.push({...employment, type: 0});
        }
      }
      if (previousHistory.education && previousHistory.education.length > 0) {
        for (const education of previousHistory.education) {
          this.candidateHistoryInfo.push({...education, type: 1});
        }
      }
      if (previousHistory.selfEmployment && previousHistory.selfEmployment.length > 0) {
        for (const selfEmployment of previousHistory.selfEmployment) {
          this.candidateHistoryInfo.push({...selfEmployment, type: 2});
        }
      }
      if (previousHistory.unEmployment && previousHistory.unEmployment.length > 0) {
        for (const unEmployment of previousHistory.unEmployment) {
          this.candidateHistoryInfo.push({...unEmployment, type: 3});
        }
      }
    },
    setApiResponseIntoSIAProps(sia) {
      if (sia && sia.length > 0) {
        this.siaInfo = sia
      }
    },
    setApiResponseIntoGdprProps(gdpr) {
      if (gdpr && Object.values(gdpr).length > 0) {

        this.$set(this.gdprInfo, 'consent', gdpr.consent === 1 ? true : false);
        this.$set(this.gdprInfo, 'consent_date_time', gdpr.consent_date_time);
        this.$set(this.gdprInfo, 'special_category_data', gdpr.special_category_data === 1 ? true : false);
        this.$set(this.gdprInfo, 'signature', gdpr.signature);
        this.$set(this.gdprInfo, 'companyInfo', this.companyInfo);
      }
    },
    setApiResponseIntoPolicyDeclrationProps(policyDeclration) {
      if (policyDeclration && Object.values(policyDeclration).length > 0) {
        this.$set(this.policyDeclarationInfo, 'applicant_screening', policyDeclration.applicant_screening === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'criminal_background_check', policyDeclration.criminal_background_check === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', policyDeclration.declaration_by_applicant === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'financial_history', policyDeclration.financial_history === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality', policyDeclration.equality === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality_details', policyDeclration.equality_details);
        this.$set(this.policyDeclarationInfo, 'working_time_directive', policyDeclration.working_time_directive);
      }
    },
    closeModal() {
      this.is_consent_modal = false;
      $("#consent-modal").modal("hide");
    },
    acceptAll() {
      this.$set(this.policyDeclarationInfo, 'applicant_screening', true);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check', true);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', true);
      this.$set(this.policyDeclarationInfo, 'financial_history', true);
      this.$set(this.policyDeclarationInfo, 'equality', true);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'yes');
      setTimeout(() => {
        this.closeModal()
      }, 1000 )

    },
    setPolicyDeclarationFields(){
      this.$set(this.policyDeclarationInfo, 'applicant_screening', false);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check',  false);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', false);
      this.$set(this.policyDeclarationInfo, 'financial_history', false);
      this.$set(this.policyDeclarationInfo, 'equality', false);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'no');
    },
    confirmSubmission(lastFormIndex) {
      if (confirm("Are you sure all the information is correct and you want to submit? You may cancel and go back to review your information." )) {
        return true; // Proceed with submission
      } else {
        this.active = 0; // Take the user back to the previous step for review
        return false;
      }
    },

    saveBtnHandler(final = true) {
      if (!final){
        if (this.lastFormIndex === this.maxStep)
         if (!this.confirmSubmission()){
           return;
         }
      }
      if (!this.checkPolicyDeclaration(this.policyDeclarationInfo)) {
        this.is_consent_modal = true;
        return;
      }

      let employment = this.candidateHistoryInfo.filter(x => x.type === 0);
      let education = this.candidateHistoryInfo.filter(x => x.type === 1);
      let selfEmployment = this.candidateHistoryInfo.filter(x => x.type === 2);
      let unEmployment = this.candidateHistoryInfo.filter(x => x.type === 3);

      this.registrationForm = {
        applicant: this.basicInfo,
        applicantPayroll: this.payrollInfo,
        applicantAddress: this.addressInfo,
        applicantTraining: this.trainingInfo,
        applicantEmployment: employment,
        applicantEducation: education,
        applicantSelfEmployment: selfEmployment,
        applicantUnemployment: unEmployment,
        applicantSiaDetail: this.siaInfo,
        applicantGdprDetail: this.gdprInfo,
        applicantPolicyDeclaration: this.policyDeclarationInfo,
        searchAction: this.searchAction ?? []
      };

      this.save(this.registrationForm);
      if (!final){
        if (this.lastFormIndex === this.maxStep)
            this.showCompletedStatus = true;
      }

    }

  },
  computed: {
    lastFormIndex(){
      return this.activeIdCollection.at(-1)
    },
    isMobile() {
      let width = window.innerWidth;
      let stepsDirection;
      // Set to vertical on small screens (less than 768px)
      if (width <= 768) {
        stepsDirection = 'vertical';
      } else {
        stepsDirection = 'horizontal';
      }
      return stepsDirection;
    },
    addUrl(){
      // Get the full URL from the browser's location
      let url = window.location.href;

// Split the URL by the '?' to separate the path from the query string
      let urlParts = url.split('?');

// Extract the part before the query string (the path)
      let path = urlParts[0];

// Split the path by '/' to get each segment
      let pathSegments = path.split('/');

// Assuming the encryptedCompanyKey is the last segment in the path
      let encryptedCompanyKey = pathSegments[pathSegments.length - 1];

// Output or use the encryptedCompanyKey
      return SCREENING_USER_REGISTRATION + '/'+encryptedCompanyKey;
    }
  }
}
</script>
<style>
.scroll-container {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  /* This ensures items stay in a single line */
}

.scroll-content {
  /* display: inline-block; */
  /* Ensures the container only takes as much width as its children */
}

/* Hide scrollbar */
.scroll-container::-webkit-scrollbar {
  display: none;
}

.el-step.is-horizontal .el-step__main .el-step__title {
  /* font-size: 14px !important; */
  padding-right: 14px !important;
  cursor: pointer;
}

.el-step__title {
  font-size: 12px !important;
  line-height: 40px !important;
  color: #292f4c !important;
}

.el-step__head.is-process .el-step__icon.is-text {
  /* background-color: #292f4c !important; */
  color: #292f4c !important;
  border-color: #292f4c !important;
}

.el-step__head.is-finish {
  color: #292f4c !important;
  border-color: #292f4c !important;
}
.el-step__head.is-finish .el-step__line .el-step__line-inner {
  border-color: #292f4c !important;
}

.el-step__head.is-finish .el-step__icon.is-text {
  background-color: #292f4c !important;
  color: white !important;
  border-color: #C0C4CC !important;
}
.el-step__head.is-finish .el-step__icon .el-step__icon-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #292f4c !important; */
  color: #fff !important;
  /* border-color: #292f4c !important; */
  position: relative;
}

/* Hide the original number by setting its content to nothing */
.el-step__head.is-finish .el-step__icon .el-step__icon-inner::before {
  content: '\2713'; /* Unicode for checkmark */
  font-size: 16px !important;
  font-weight: bold;
}

/* Make sure to hide any existing text inside the icon */
.el-step__head.is-finish .el-step__icon .el-step__icon-inner {
  content: ""; /* Remove any existing text */
  font-size: 0; /* Ensures no step number shows */
}

/* Need to set this CSS its not working here. */
/* .el-step.is-horizontal .el-step__main .el-step__title {
  font-size: 14px !important;
  padding-right: 14px !important;
  cursor: pointer;
} */
</style>
